module.exports = __webpack_public_path__ + "static/img/mogos@2x.aef4d53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect/mogos@2x.png
// module id = 92
// module chunks = 0